import { BaseStore } from "./base_store";
import { makeAutoObservable, runInAction } from "mobx"
import DedicatedAssignmentAPI from "../api/dedicated_assignment_api";
import { api_get } from "api/utils";


export type DedicatedAssignmentProps = {
	key: string;
	identity: string;
	assistant_identity: string;
    ranking: number;
	date_created: string;
	updateProps: (attributes: DedicatedAssignmentProps) => void;
};

// Domain object DedicatedAssignment
export class DedicatedAssignment implements DedicatedAssignmentProps {

	key = "";
	user = "";
	identity = "";
    assistant_identity = "";
    ranking = 0;
	date_created = "";

	constructor(attributes: DedicatedAssignmentProps) {
		makeAutoObservable(this, {
			updateProps: false
		})
		if(attributes) {
			this.updateProps(attributes);
        }
	}

	updateProps(attributes: DedicatedAssignmentProps) {
		runInAction(() => {
			Object.assign(this, attributes);
		})
		// Object.assign(this, attributes);
	}

}


export class DedicatedAssignmentStore extends BaseStore<DedicatedAssignmentProps, DedicatedAssignment> {


	async fetchByIdentity(workKey: string, client_identity: string, cursor='') {
		return DedicatedAssignmentAPI.fetchByIdentity(workKey, client_identity, cursor).then((resp) => {
			this.receiveUpdate(resp.items)
            if(resp.cursor) {
                this.fetchByIdentity(workKey, client_identity, resp.cursor);
            }
		})
	}

	async fetchByAssistantIdentity(assistantIdentityKey: string, cursor="") {
		return DedicatedAssignmentAPI.fetchByAssistantIdentity(assistantIdentityKey, cursor).then((resp) => {
			this.receiveUpdate(resp.items)
            if(resp.cursor) {
                this.fetchByAssistantIdentity(assistantIdentityKey, resp.cursor);
            }
            return resp.items;
		})
	}

	async supportAssign(identityKey: string, assistantIdentityKey: string, ranking: number) {
		return DedicatedAssignmentAPI.supportAssign(identityKey, assistantIdentityKey, ranking.toString()).then((resp) => {
			this.receiveUpdate(resp)
            return resp as DedicatedAssignment;
		})
	}

	async supportRemove(identityKey: string, assistantIdentityKey: string) {
		return DedicatedAssignmentAPI.supportRemove(identityKey, assistantIdentityKey).then(() => {
            this.items = this.items.slice().filter((item) => {
                return (item.identity != identityKey && item.assistant_identity != assistantIdentityKey);
            })
		})
	}

    async fetchAll(workKey: string, cursor = "") {
        return api_get('/dedicated-assignment/all', { identity: workKey, cursor })
            .then(async (resp) => {
                const data = await resp.json();
                this.receiveUpdate(data.items);
                if (data.cursor) {
                    this.fetchAll(workKey, data.cursor);
                }
            });
    }

	modelConstructor() {
		return DedicatedAssignment;
	}

}
